import React, { useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Spin } from 'antd';
import moment from 'moment';

import Modal from "../../components/uiComponent/modal/index";
import Input from "../../components/uiComponent/inputs/labelInput/index"
import Select from "../../components/uiComponent/select/index";

import { WarehouseWrapper } from "./style";

import {
  AdjustInventory,
  setField,
  GetLocationProducts
} from "../../slices/location-management";

import {STORAGE_IMAGE_URL} from '../../constants/storage';
const ProductImg = `${STORAGE_IMAGE_URL}/newImages/nestle.svg`;

const InventoryAdjustment = ({
  showInventoryAdjustmentModal,
  setShowInventoryAdjustmentModal,
  selectedIndex,
  locationId,
  page,
  filters,
  sortBy,
  zeroEntriesSwitch
}) => {
  const dispatch = useDispatch();

  const [inventoryAdjustmentData, setInventoryAdjustmentData] = useState({ quantity: '', type: '', reason: '' });

  const {
    adjustingInventory,
    locationProducts,
  } = useSelector((state) => state?.locationManagement || {});

  const handleSaveData = () => {
    dispatch(AdjustInventory({
      ...inventoryAdjustmentData,
      location_distribution_id
    })).then(({ payload }) => {
      if (payload?.success) {
        const { quantity: newQuantity, type } = inventoryAdjustmentData || {};
        const value = (type === 'Add') ? (quantity + Number(newQuantity)) : (quantity - newQuantity);

        dispatch(setField({
          field: 'locationProducts',
          index: selectedIndex,
          key: 'quantity',
          value
        }));
        handleCloseModal();
        dispatch(GetLocationProducts({
          id: locationId,
          params: {
            page,
            filters,
            sortBy,
            showZeroFlag: zeroEntriesSwitch
          }
        }));
      }
    });
  };

  const handleCloseModal = () => {
    setShowInventoryAdjustmentModal(false);
    setInventoryAdjustmentData({ quantity: '', type: '', reason: '' });
  };

  const adjustmentTypes = [
    { value: 'Add', label: 'Add' },
    { value: 'Deduct', label: 'Deduct' }
  ];

  const { quantity = 0, expiry_date, id: location_distribution_id, products_v2 } = locationProducts?.[selectedIndex] || {};
  const { name: productName, image_url } = products_v2 || {};
  const expiryDate = expiry_date ? moment(expiry_date).format('MM/DD/YYYY') : '---';

  return (
    <>
      <Modal
        open={showInventoryAdjustmentModal}
        onHide={handleCloseModal}
        onClose={handleCloseModal}
        onSave={handleSaveData}
        header={false}
        removeIcon
        closeText="Cancel"
        saveText="Submit"
        closeButton={true}
        buttonDisabled={false}
        size="md"
        className="delete-confirmation-modal inventory-adjustment-modal-wrapper"
        centerAlign={false}
      >
        <WarehouseWrapper>
          <Spin tip="Loading..." spinning={adjustingInventory}>
            <div className="Inventory-adjustment-content-wrapper">
              <h6>Inventory adjustment</h6>
              <div className="item-container">
                <div className="item-wrapper">
                  <div className="item-title">
                    <img src={image_url || ProductImg} />
                    <p>{productName}</p>
                  </div>
                </div>
                <div className="bar-items">
                  <p>Quantity:</p>
                  <p>{quantity}</p>
                </div>
                <div className="bar-items">
                  <p>Expire Date:</p>
                  <p>{expiryDate}</p>
                </div>
              </div>
              <div className="inventory-inputs-wrapper">
                <div className="items-wrapper">
                  <Select
                    isClearable={true}
                    placeholder="Select"
                    label="Type"
                    className="mb-0"
                    important={true}
                    options={adjustmentTypes}
                    onChange={(e) => setInventoryAdjustmentData(inventoryAdjustmentData => ({ ...inventoryAdjustmentData, type: e?.value || '' }))}
                  />
                  <Input
                    label="Quantity"
                    placeholder="Enter"
                    required={true}
                    onChange={({ target }) => setInventoryAdjustmentData(inventoryAdjustmentData => ({ ...inventoryAdjustmentData, quantity: target.value || '' }))}
                  />
                </div>
                <div className="textarea-reason-wrapper">
                  <Input
                    label="Reason"
                    placeholder="Enter"
                    as="textarea"
                    onChange={({ target }) => setInventoryAdjustmentData(inventoryAdjustmentData => ({ ...inventoryAdjustmentData, reason: target.value || '' }))}
                  />
                </div>
              </div>
            </div>
          </Spin>
        </WarehouseWrapper>
      </Modal>
    </>
  );
}

export default InventoryAdjustment